import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './WorkingOnFeedback.css';

/* AI-style "working on your feedback" animation, shown while the results are computed.
   Pure presentation — a pulsing orb, a step-by-step status line, and a progress bar — to make
   the reveal feel like the model is genuinely working. Used by the public Company Readiness
   Scan and Employee Pulse. */

const LINE_MS = 850;   // how long each status line shows before advancing to the next

const WorkingOnFeedback = () => {
  const { t } = useTranslation();
  const lines = [
    t('feedbackWorking1'), t('feedbackWorking2'), t('feedbackWorking3'),
    t('feedbackWorking4'), t('feedbackWorking5'), t('feedbackWorking6'),
    t('feedbackWorking7'), t('feedbackWorking8'), t('feedbackWorking9'),
  ];
  const [idx, setIdx] = useState(0);

  // Step through the lines and HOLD on the last one, so a slower compute ends on "Almost there"
  // instead of looping back to the first line (which would read as a restart).
  useEffect(() => {
    const id = setInterval(() => setIdx((n) => Math.min(n + 1, lines.length - 1)), LINE_MS);
    return () => clearInterval(id);
  }, [lines.length]);

  const pct = Math.round(((idx + 1) / lines.length) * 100);

  return (
    <div className="working-fb" role="status" aria-live="polite">
      <div className="working-fb__orb">
        <span /><span /><span />
      </div>
      <p className="working-fb__line">
        {lines[idx]}
        <span className="working-fb__dots"><i>.</i><i>.</i><i>.</i></span>
      </p>
      <div className="working-fb__bar" aria-hidden="true">
        <div className="working-fb__barfill" style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
};

export default WorkingOnFeedback;
